




























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BoxContainer from "@/components/Container/BoxContainer.vue";
import SpecialHeader from "./SpecialHeader.vue";
import SingleOffer from "./SingleOffer.vue";
import MultOffer from "./MultOffer.vue";
import SpecialOfferController from "@/services/special_offer/special_offer_controller";
import { Offer } from "@/services/offer/offer_handle";
import {payByAny} from "@/services/payment/payment_check/payment_check_logic";
import { Getter } from "vuex-class";
import { GETTER_PAGE_SETTING_STATUS } from "@/store/constants/setting_types";
import EventBus from "@/utils/event_bus";

@Component({
  components: { BoxContainer, SpecialHeader, SingleOffer, MultOffer }
})
export default class SpecialOffer extends Vue {
  @Prop({ default: "follow" })
  private type!: string;
  @Getter(GETTER_PAGE_SETTING_STATUS)
  private getterPageOnlineSettingStatus: any;

  private isShow: any = false;
  private controller: any;
  private countDownTimeStamp: any = 0;
  private specilOffers: any = [];
  private hasLogEvent: boolean = false;

  get pageOnlineSetting() {
    return this.getterPageOnlineSettingStatus(this.type);
  }

  get isSingleOffer() {
    return this.specilOffers.length === 1;
  }

  get text() {
    return this.type === "follow" ? "Followers" : "Likes";
  }

  get singleOffer() {
    return this.specilOffers[0];
  }

  get offerDiscount() {
    return `${this.specilOffers[0].discount}%`;
  }

  get isFollow() {
    return this.type === "follow";
  }

  get iconName() {
    return this.isFollow ? "icon-app_follower_white" : "icon-app_like_white";
  }

  @Watch("pageOnlineSetting", { immediate: true })
  private watchOnlineSetting(val: any) {
    this.initSpecialOffer();
  }

  // 通过倒计时结束的方式，触发跳入special offer的下一个阶段
  private async goSpecialOffersNextStage(flag = true) {
    const result = this.controller.stageNextStep(flag);
    // 只在倒计时结束触发，因为手动购买进入下一阶段，会重新进入组件触发created或者actived钩子，使show打点重复
    this.getRenderData(result);
  }

  private async getRenderData(controlData: any) {
    this.isShow = controlData.isShow;
    this.specilOffers = controlData.offerInfo && controlData.offerInfo.offers;
    this.countDownTimeStamp = controlData.durationTimeStamp;
    console.log("getRenderData===", controlData, this.countDownTimeStamp);
    await this.controller.updateIndexDB();
  }

  // 在init的阶段必须保存实例数据到DB，为了避免当DB里没有数据时同步失败
  private async initSpecialOffer() {
    this.controller = new SpecialOfferController();
    const result = await this.controller.init(this.type);
    this.getRenderData(result);
  }

  private buyOffer(offer: Offer) {
    console.log("buyOffer offer", offer);
    payByAny({offer});
    EventBus.$off("special_offer_buying_finished");
    EventBus.$once("special_offer_buying_finished", () => {
      this.goSpecialOffersNextStage(false);
    });
  }

  private created() {
    if (!this.hasLogEvent) {
      this.initSpecialOffer();
    }
    this.hasLogEvent = true;
  }

  private activated() {
    if (!this.hasLogEvent) {
      this.initSpecialOffer();
    }
    this.hasLogEvent = true;
  }

  private destroyed() {
    this.hasLogEvent = false;
  }

  private deactivated() {
    this.hasLogEvent = false;
    /**
     * 必须要在失活时重置special offer，否则组件会缓存当前状态。下次进入路由激活组件时，上次缓存的倒计时会立马触发进入下一阶段，进行show打点，避免初始化打点一次，进入下一阶段同时再打点一次
     */
    this.countDownTimeStamp = 0;
    this.isShow = false;
    this.specilOffers = [];
  }
}
